import { OreDivider, OreHeading, OreStack } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { createApiAutoEnrollmentRepository } from '@/AutoEnrollment/infrastructure'
import { AutoEnrollmentTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { AutoEnrollmentProvider } from '@/AutoEnrollment/ui/context'
import { AutoEnrollmentStepper } from '@/AutoEnrollment/ui/organisms'
import { PageWrapper } from '@/Shared/ui/layout'

export const AutoEnrollmentPage = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <AutoEnrollmentProvider repository={createApiAutoEnrollmentRepository()}>
      <PageWrapper paddingTop={12} style={{ maxWidth: '900px' }}>
        <OreHeading as="h1" size="title-md">
          {t(AutoEnrollmentTranslation.pageTitle)}
        </OreHeading>
        <OreDivider space="larger-bottom" />
        <OreStack space="large" placeContent="stretch">
          <AutoEnrollmentStepper />
        </OreStack>
      </PageWrapper>
    </AutoEnrollmentProvider>
  )
}
